export const scriptTagDefault = '<script>\n\n</script>'
